import { Component, OnInit } from '@angular/core';
import { DataproviderService } from 'src/app/dataprovider.service';
import { ProgressiveBarService } from 'src/app/shared/progressive-bar/progressive-bar.service';
import { WebcallsService } from 'src/app/webcalls.service';
import { CommonService } from '../common.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-send-quotation',
  templateUrl: './send-quotation.component.html',
  styleUrls: ['./send-quotation.component.scss']
})
export class SendQuotationComponent implements OnInit {
  title: string = "b2c.IDS_SENDQUOTATION";
  subtitle: string = "b2c.IDS_SENDQUOTATION_SUB";
  question: string = "b2c.IDS_SENDQUOTATION_QUE";
  showSubtitle: boolean = true;
  activePage: string = "send";
  nextPage: string = "";
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "";
  sendFormGroup: UntypedFormGroup;

  constructor(
    private cs: CommonService,
    private ws: WebcallsService,
    private ds: DataproviderService,
    private progressiveBarService: ProgressiveBarService) {
    this.cs.setParams(
      this.title,
      this.subtitle,
      this.question,
      this.activePage,
      this.nextPage,
      false,
      false,//7-g
      false,//8-h
      false,
      null,
      false,
      false,
      this.eventCategory,
      this.eventLabel,
      false,
      null,
      true,
      this.showSubtitle,
      false,
      '',
      '',
      true
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(3);
  }

  ngOnInit(): void {      
    this.sendFormGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, [Validators.required]),
      surname: new UntypedFormControl(null, [Validators.required]),
      email: new UntypedFormControl(null, [Validators.required, Validators.email]),
      telephone: new UntypedFormControl(null, [Validators.required]),
      province: new UntypedFormControl(null, [Validators.required]),
      city: new UntypedFormControl(null, [Validators.required]),
      postalcode: new UntypedFormControl(null, []),
      address: new UntypedFormControl(null, []),
      message: new UntypedFormControl(null, []),
      privacy: new UntypedFormControl(null, [Validators.requiredTrue]),
      share: new UntypedFormControl(null, [Validators.requiredTrue])
    });

       
    let formData = this.ds.sendQuotationFormData;
    if (formData) {
      this.sendFormGroup.setValue(formData);
      this.setSendButtonStatus();
    }

    this.sendFormGroup.statusChanges.subscribe(status => {
      if (status === "VALID") {
        this.ds.sendQuotationFormData = this.sendFormGroup.value;
        this.setSendButtonStatus();
      } else {
        this.setSendButtonStatus();
      }
    })    
  }

  ngOnDestroy() {
    this.ds.sendQuotationFormData = this.sendFormGroup.value;
  }
  private setSendButtonStatus(): void {
    let formValid = this.sendFormGroup.status === "VALID";    
     
    if (formValid) {
      this.cs.updateSendInstallerBtn(true);
    } else {
      this.cs.updateSendInstallerBtn(false);
    }
  }
}
